import { defineSlotRecipe } from '@chakra-ui/react';
import { nativeSelectAnatomy } from '@chakra-ui/react/anatomy';

import { selectTriggerHeightPx } from './select.kds';

/** KDS native `<select>` — aligned with outline Select triggers. */
export const nativeSelectSlotRecipe = defineSlotRecipe({
  slots: nativeSelectAnatomy.keys(),
  base: {
    field: {
      borderRadius: 'md',
      borderWidth: '1px',
      borderColor: 'neutral.250',
      bg: 'neutral.0',
      color: 'neutral.500',
      textStyle: 'default.regular',
      _hover: {
        borderColor: 'neutral.350',
      },
      _focus: {
        borderColor: 'brand.500',
        outline: 'none',
      },
      _disabled: {
        bg: 'neutral.50',
        borderColor: 'neutral.200',
        color: 'neutral.350',
        opacity: 1,
      },
      '&[data-invalid], &[aria-invalid="true"]': {
        borderColor: 'red.500',
      },
    },
    indicator: {
      color: 'neutral.250',
    },
  },
  variants: {
    size: {
      sm: {
        field: {
          ps: 2,
          height: `${selectTriggerHeightPx.sm}px`,
        },
      },
      md: {
        field: {
          ps: 2,
          height: `${selectTriggerHeightPx.md}px`,
        },
      },
      lg: {
        field: {
          ps: 2,
          height: `${selectTriggerHeightPx.lg}px`,
          textStyle: 'large.regular',
        },
      },
    },
  },
  defaultVariants: {
    size: 'md',
  },
});
